import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import { Box } from '@mui/material';

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(4),
    paddingTop: '4px !important',
  },
  '& .MuiDialogTitle-root': {
    padding: theme.spacing(4),
  },
}));

export const Header = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
});
